import { render, staticRenderFns } from "./DeleteGroupModal.html?vue&type=template&id=4e9179e0&scoped=true&"
import script from "./DeleteGroupModal.vue?vue&type=script&lang=js&"
export * from "./DeleteGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteGroupModal.scss?vue&type=style&index=0&id=4e9179e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9179e0",
  null
  
)

export default component.exports